<template>
  <div class="home-page">
    <div class="content-panel">
      <h1 class="aspire-heading-1">
        All-in-one finance for growing businesses
      </h1>
      <div class="aspire-desc">
        Save time and money with borderless payments, corporate cards, expense
        management, and more. All in one account.
      </div>
      <div class="aspire-buttons aspire-buttons--center">
        <a
          target="_blank"
          href="https://app.aspireapp.com/sg/register"
          class="aspire-button"
          >Get started for free</a
        >
        <a
          target="_blank"
          href="https://app.aspireapp.com/sg/register"
          class="aspire-button aspire-button--plain"
          >Talk to an expert</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
<style lang="scss" scoped>
</style>